import { COVER_EXPORT_PX } from 'fym-shared/src/music24/coverDoc';
import { coverHasWatermark } from 'fym-shared/src/music24/coverEditorPlans';
import type { Music24PlanTier } from 'fym-shared/src/music24/music24Plans';

/**
 * The sides the export tries, largest first. A browser that refuses a 3000 px canvas (an old phone)
 * gets a smaller file; never under `COVER_EXPORT_MIN_PX`, the smallest side that the API accepts.
 */
export const COVER_EXPORT_SIDES: readonly number[] = [COVER_EXPORT_PX, 2048, 1400];
export const COVER_EXPORT_MIN_PX = 1400;
export const COVER_EXPORT_JPEG_QUALITY = 0.92;

/**
 * True when the file carries the Music24 watermark (owner decision D7): the API says so for the
 * workspace (`watermark`), and the plan rule says so for Free and the trial. Either one is enough,
 * so a stale answer never removes the mark. Pure.
 */
export function coverExportWatermark(input: { apiWatermark: boolean; plan: Music24PlanTier | null }): boolean {
  return input.apiWatermark || coverHasWatermark(input.plan);
}

// eslint-disable-next-line no-control-regex -- control characters are not valid in a file name
const unsafe = /[\u0000-\u001f\u007f<>:"/\\|?*]+/g;

/** A part of a file name with no character that a file system refuses. Pure. */
function safePart(value: string): string {
  return value.replace(unsafe, ' ').replace(/\s+/g, ' ').trim().slice(0, 60);
}

/** The name of the downloaded file: "<Artist> - <Song> - Cover <side>x<side>.jpg". Pure. */
export function coverExportFileName(input: { artist: string; title: string; side: number }): string {
  const parts = [safePart(input.artist), safePart(input.title)].filter((part) => part !== '');
  return `${[...parts, `Cover ${input.side}x${input.side}`].join(' - ')}.jpg`;
}
